import Typography from '@mui/material/Typography';
import React, { useCallback, useMemo } from 'react';
import { Trans } from 'react-i18next';

import { useConfigContext } from '@/context/ConfigContext';
import styled from '@emotion/styled';
import { AnalyticClient, DocumentTypes, getPathnameFromUrl } from '@repo/utils';
import { publicRuntimeConfig } from '@repo/config';

const defaultLinkProps = { passHref: true, target: '_blank' };

const Link = styled.a`
  color: var(--olymp-robot-primary, #0094ff);
  cursor: pointer;
  text-decoration: none;
  font-weight: 500;
`;

const TermsText: React.FC = () => {
  const {
    configState: { value },
  } = useConfigContext();

  const handleOpenLinkClick = useCallback((type: DocumentTypes) => {
    AnalyticClient.track({
      type: 'Terms - Open',
      data: { type },
    });
  }, []);

  const robotTermsConditionsUrl = useMemo(() => {
    return getPathnameFromUrl(value?.robot_terms_conditions_url, '/terms');
  }, [value?.platform_terms_conditions_url]);
  const robotPrivacyPolicyUrl = useMemo(() => {
    return getPathnameFromUrl(value?.robot_privacy_policy_url, '/terms/privacy-policy');
  }, [value?.platform_privacy_policy_url]);

  return (
    <Typography
      sx={{
        color: 'var(--common-text-grey, #98A4B3)',
        fontSize: '12px',
        lineHeight: 1.33,
        marginTop: '16px',
      }}
    >
      <Trans
        ns="common"
        i18nKey="link.terms_privacy"
        tOptions={{ appName: publicRuntimeConfig.app.name }}
        components={{
          LandingTerms: (
            <Link
              {...defaultLinkProps}
              href={robotTermsConditionsUrl}
              onClick={() => handleOpenLinkClick('Our Terms')}
            />
          ),
          LandingPrivacy: (
            <Link
              {...defaultLinkProps}
              href={robotPrivacyPolicyUrl}
              onClick={() => handleOpenLinkClick('Our Policy')}
            />
          ),
          PlatformTerms: (
            <Link
              {...defaultLinkProps}
              href={value?.platform_terms_conditions_url}
              onClick={() => handleOpenLinkClick('Platform Terms')}
            />
          ),
          PlatformPrivacy: (
            <Link
              {...defaultLinkProps}
              href={value?.platform_privacy_policy_url}
              onClick={() => handleOpenLinkClick('Platform Privacy')}
            />
          ),
        }}
      />
    </Typography>
  );
};

export default React.memo(TermsText);
